module.exports = __webpack_public_path__ + "img/icon-esperienze.bdfc0c4c.svg";